import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { IVideoWatchProgress } from '../models/models'

export class GetMyVideoProgressApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'Video/getMyProgress',
      requesterInfo,
    })
  }

  public async getMyProgress(categoryId: number): Promise<IVideoWatchProgress[]> {
    return await this.getAsync<IVideoWatchProgress[]>(categoryId.toString())
  }
}
